export default __webpack_public_path__ + "static/media/circleImages.0b4e9d57.jpg";